export const QR_COLOR = '#334155'

export const QR_BLANK_PIXEL = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='

export const QR_LOGO_RATIO = 48 / 184

export const QR_EXPORT_SIZE = 1024

export const qrLogoSettings = (logo: string | undefined, qrSize: number) => {
  if (!logo) return undefined
  const size = Math.round(qrSize * QR_LOGO_RATIO)
  return { src: QR_BLANK_PIXEL, width: size, height: size, excavate: true }
}

export const qrFileName = (brandName?: string) => {
  const slug = (brandName ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
  return slug ? `qr-${slug}.png` : 'qr-code.png'
}

const loadImage = (src: string) =>
  new Promise<HTMLImageElement>((resolve, reject) => {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.onload = () => resolve(img)
    img.onerror = () => reject(new Error('logo'))
    img.src = src
  })

const drawRoundedImage = (ctx: CanvasRenderingContext2D, img: HTMLImageElement, x: number, y: number, size: number) => {
  const scale = Math.max(size / img.width, size / img.height)
  const w = img.width * scale
  const h = img.height * scale
  ctx.save()
  ctx.beginPath()
  ctx.roundRect(x, y, size, size, size * 0.3)
  ctx.clip()
  ctx.drawImage(img, x + (size - w) / 2, y + (size - h) / 2, w, h)
  ctx.restore()
}

export const exportQrPng = async (
  qrCanvas: HTMLCanvasElement,
  logo?: string
): Promise<{ dataUrl: string; logoDrawn: boolean }> => {
  const plain = { dataUrl: qrCanvas.toDataURL('image/png'), logoDrawn: !logo }
  if (!logo) return plain
  try {
    const img = await loadImage(logo)
    const canvas = document.createElement('canvas')
    canvas.width = qrCanvas.width
    canvas.height = qrCanvas.height
    const ctx = canvas.getContext('2d')
    if (!ctx) return plain
    ctx.drawImage(qrCanvas, 0, 0)
    const size = Math.round(canvas.width * QR_LOGO_RATIO * (40 / 48))
    const offset = (canvas.width - size) / 2
    drawRoundedImage(ctx, img, offset, offset, size)
    return { dataUrl: canvas.toDataURL('image/png'), logoDrawn: true }
  } catch {
    return plain
  }
}
